<div class="content">
  <span class="title">{{ "config_notification.title" | translate }}</span>
  <div class="dive"></div>

  <mat-tab-group #myTabGroup (selectedIndexChange)="isInforTab = $event">
    <mat-tab [label]="'config_notification.title' | translate">
      <form [formGroup]="form">
        <div class="reminder-to-sign">
          {{ 'config_notification.title' | translate }}
          <mat-button-toggle-group class="toggle-button">
            <mat-button-toggle [checked]="isActive" id="on-button" [value]="isActive" (click)="clickSend(true)">
              {{ 'search_form.btn_config_notify_on' | translate }}
            </mat-button-toggle>
            <mat-button-toggle [checked]="!isActive" [value]="!isActive" (click)="clickSend(false)">
              {{ 'search_form.btn_config_notify_off' | translate }}
            </mat-button-toggle>
          </mat-button-toggle-group>
        </div>

        <ng-container *ngIf="isActive">
          <div class="reminder-to-sign">
            {{ 'config_notification.mean_send_notification' | translate }}
            <mat-checkbox class="mat-checkbox" color="primary" formControlName="isSendSms">SMS</mat-checkbox>
            <mat-checkbox class="mat-checkbox" color="primary" formControlName="isSendEmail">Email</mat-checkbox>
          </div>
          <div class="error-message" *ngIf="form.errors?.required">
            {{ 'config_notification.message.notification_required' | translate }}
          </div>

          <!-- Chu kỳ nhắc ký -->
          <div class="reminder-to-sign">
            <mat-form-field class="w-100">
              <input matInput type="number" formControlName="reminderCycle" min="1" max="366"
                     [placeholder]="'search_form.cycle_send_sign' | translate"
                     class="input-cycle" required
                     (blur)="normalizeValue($event)"
                     (keypress)="onlyNumber($event)" />
              {{ 'search_form.day_time' | translate }}
              <mat-error *ngIf="form.get('reminderCycle')?.hasError('required')">
                {{ 'config_notification.message.reminderCycle_required' | translate }}
              </mat-error>
              <mat-error *ngIf="form.get('reminderCycle')?.hasError('min') || form.get('reminderCycle')?.hasError('max')">
                {{ 'config_notification.message.reminderCycle_value' | translate }}
              </mat-error>
            </mat-form-field>
          </div>

          <div class="reminder-to-sign" style="padding-top: 0;">
            <span style="font-style: italic; font-weight: normal;">
              <span style="color: red;">{{ 'search_form.note_remind_sign_contract_pre' | translate }}</span>
              {{ 'config_notification.note_info' | translate }}
            </span>
          </div>

          <div class="w-100 search-user">
            <nz-input-group [nzSuffix]="suffixUserInput">
              <input nz-input [(ngModel)]="inputUserSignValue" (input)="onChangeUserSearch($event)"
                     [nzAutocomplete]="autoUserSignSearching" [ngModelOptions]="{ standalone: true }"
                     placeholder="{{ 'placeholder.config_notification_search' | translate }}" #autocompleteInput id="inputUserSign" />
              <nz-autocomplete #autoUserSignSearching>
                <nz-auto-option *ngFor="let user of filteredUserOptions" (selectionChange)="autocompleteUserSignSelected($event, user)" [nzValue]="''">
                  <div *ngIf="user.type === 'DEPARTMENT'" class="row-icon department">
                    <span class="material-icons">apartment</span>{{ user.departmentCode }} - {{ user.departmentName }}
                  </div>
                  <div class="row-icon user" *ngIf="(user.type === 'DEPARTMENT' && user.representativeId) || user.type === 'USER'"
                       [class.disabled]="!user.representativeIsActive && user.type === 'DEPARTMENT'">
                    <span class="material-icons" *ngIf="user.type === 'USER'">person</span> {{ user.name }} - {{ user.email }}
                    <span *ngIf="!user.representativeIsActive && user.type === 'DEPARTMENT'">{{ "enterprise_contract.panel_document.table_users.representative_inactive" | translate }}</span>
                  </div>
                  <div class="row-icon disabled user" *ngIf="!user.representativeId && user.type === 'DEPARTMENT'">
                    {{ "enterprise_contract.panel_document.table_users.no_representative_text" | translate }}
                  </div>
                  <hr style="margin: 0; padding: 0" />
                </nz-auto-option>
              </nz-autocomplete>
            </nz-input-group>
            <ng-template #suffixUserInput>
              <nz-spin *ngIf="nzCheckLoadingUser" nzSimple [nzIndicator]="indicatorUserInput"></nz-spin>
            </ng-template>
            <ng-template #indicatorUserInput>
              <i class="nz-icon-font" nz-icon nzType="loading" style="font-size: 24px"></i>
            </ng-template>
          </div>

          <span class="table-title">{{ 'config_notification.table-title' | translate }} ({{ users.length }})</span>
          <div class="table-user">
            <mat-table [dataSource]="users" class="mat-table-col-extra-sm" style="overflow-x: auto;">
              <ng-container matColumnDef="STT">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom" style="min-width: 10%; max-width: 10%;">
                  {{ 'enterprise_contract.table_headers.No' | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element; let i = index" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                          style="min-width: 10%; max-width: 10%;">
                  {{ i + 1 }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom" style="min-width: 40%; max-width: 40%;">
                  {{ 'config_notification.user_name_department' | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom" style="min-width: 40%; max-width: 40%;">
                  <div class="name-user-department">
                    <div *ngIf="element.type === 'DEPARTMENT'" class="row-icon department">
                      <span class="material-icons">apartment</span>{{ element.departmentCode }} - {{ element.departmentName }}
                    </div>
                    <div class="row-icon user" *ngIf="(element.type === 'DEPARTMENT' && element.representativeId) || element.type === 'USER'"
                         [class.disabled]="!element.representativeIsActive && element.type === 'DEPARTMENT'">
                      <span class="material-icons" style="top: 50%;" *ngIf="element.type === 'USER'">person</span> {{ element.name }}
                      <span *ngIf="element.email && element.type === 'DEPARTMENT'">- {{ element.email }}</span>
                      <span *ngIf="!element.representativeIsActive && element.type === 'DEPARTMENT'">{{ "enterprise_contract.panel_document.table_users.representative_inactive" | translate }}</span>
                    </div>
                    <div class="row-icon disabled user" *ngIf="!element.representativeId && element.type === 'DEPARTMENT'">
                      {{ "enterprise_contract.panel_document.table_users.no_representative_text" | translate }}
                    </div>
                  </div>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="email">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom" style="min-width: 20%; max-width: 20%;">
                  {{ 'config_notification.email' | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" matTooltip="{{ element.type === 'USER' ? element.email : '' }}"
                          class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()"
                          style="min-width: 20%; max-width: 20%;">
                  <span class="fix-width" *ngIf="element.type === 'USER'">{{ element.email }}</span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="phoneNumber">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom" style="min-width: 20%; max-width: 20%;">
                  {{ 'config_notification.phone_number' | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" matTooltip="{{ element.type === 'USER' ? element.phone : '' }}"
                          class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()"
                          style="min-width: 20%; max-width: 20%;">
                  <span class="fix-width" *ngIf="element.type === 'USER'">{{ element.phone }}</span>
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="action">
                <mat-header-cell *matHeaderCellDef class="mat-header-cell-center" style="min-width: 10%; max-width: 10%;">
                  {{ 'headertable.action' | translate }}
                </mat-header-cell>
                <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()" class="number-cell-center" style="min-width: 10%; max-width: 10%;">
                  <a nz-popconfirm [nzIcon]="iconDel" nzPopconfirmTitle="{{ 'popup.confirm_delete_user_branch' | translate }}"
                     (nzOnConfirm)="onClickDeleteElementUser(element)" nzCancelText="{{ 'button.cancel' | translate }}"
                     nzOkText="{{ 'button.ok' | translate }}">
                    <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                  </a>
                  <ng-template #iconDel>
                    <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
                  </ng-template>
                </mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="columnDefinitions; sticky: true"></mat-header-row>
              <mat-row *matRowDef="let row; columns: columnDefinitions;" matRipple class="element-row"></mat-row>
            </mat-table>
          </div>
        </ng-container>

        <div style="margin-top: 20px; display: flex; flex-direction: row; justify-content: center; align-items: center;">
          <button mat-stroked-button color="primary" class="mr-3 button" type="button" (click)="onBtnCancelClick()">
            <mat-icon class="mr-0">cancel</mat-icon>
            {{ 'button.cancel' | translate }}
          </button>
          <button mat-raised-button color="primary" class="button" [disabled]="checkEnableSave()" (click)="onSubmit()">
            <mat-icon class="mr-0">save</mat-icon>
            {{ 'config_notification.save_config' | translate }}
          </button>
        </div>
      </form>
    </mat-tab>

    <mat-tab [label]="'title.other_tab' | translate">
      <app-enterprise-config-enterprise

      ></app-enterprise-config-enterprise>
    </mat-tab>
  </mat-tab-group>
</div>
